import React from 'react';
import { connect } from 'dva';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Row, Col, Table, Tooltip, Spin, Icon, Button, Modal } from 'antd';
import { Link } from 'dva/router';
import moment from 'moment';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../../components';
import { PencilIcon, SelectIcon, TrashIcon } from '../../Icons';
import {
  ACTION_APP_GO_TO_ROUTE,
  ACTION_APP_SHOW_NOTIFICATION,
} from '../../../models/app';
import {
  ACTION_CLIENTS_DELETE,
  ACTION_CLIENTS_LOADLIST,
} from '../../../models/clients';
import styles from './../styles.less';
import { ROUTE_CLIENTS_NEW } from '../../../routes';
import { clientStatusToTextLabel } from '../constants';
import ClientsFilter from '../ClientsFilter/ClientsFilter';

const { Column } = Table;

class ClientsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removedId: 0,
      filter: {
        search: undefined,
        statuses: [],
        clientPackageIds: [],
      },
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Administration.Clients.List.Title',
        description: 'Component.Administration.Clients.List.Description',
      },
    });

    this.showNotifications();
  }

  getData = (psf) => {
    const filter = {
      name: this.state.filter.search,
      status: this.state.filter.statuses,
      client_package_id: this.state.filter.clientPackageIds,
    };
    const payload = { filter, ...psf };

    if (Object.keys(this.state.filter).length > 0) {
      payload.filtered = true;
    }

    return this.props.dispatch({ type: ACTION_CLIENTS_LOADLIST, payload });
  };

  goToClientsNew = () => {
    this.props.dispatch({
      type: ACTION_APP_GO_TO_ROUTE,
      payload: { routeName: ROUTE_CLIENTS_NEW },
    });
  };

  showNotifications() {
    this.props.dispatch({ type: ACTION_APP_SHOW_NOTIFICATION });
  }

  selectClient(client) {
    this.props.dispatch({
      type: 'app/selectClient',
      payload: {
        clientId: client.id,
        client,
      },
    });
  }

  updateFiltersState = (filter) => {
    this.setState({ filter: { ...this.state.filter, ...filter } });
  }

  showDeleteConfirm = (client) => {
    Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage(
        { id: 'Component.Administration.Clients.Remove.Modal.Description' },
        { client: client.name },
      ),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk: () => this.removeClient(client),
    });
  }

  removeClient = (client) => {
    this.props
      .dispatch({ type: ACTION_CLIENTS_DELETE, payload: { id: client.id } })
      .then((success) => {
        if (!success) {
          return;
        }

        if (+this.props.app.selectedClient.id === +client.id) {
          this.props.dispatch({ type: 'app/getDefaultSettings' });
        }

        this.showNotifications();
        this.setState({ removedId: client.id });
      });
  }

  render() {
    const { filter } = this.state;
    const { loading, app } = this.props;
    const selectedClientId = app.selectedClient.id;

    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row gutter={6}>
              <SearchComponent
                self={this}
                span={8}
                fieldPlaceholder={this.props.intl.formatMessage({
                  id: 'Component.Administration.Clients.List.SearchByNamePlaceholder',
                })}
              />
              <ClientsFilter
                onChange={this.updateFiltersState}
                formFields={this.state.filter}
              />
              <Col span={6} className="text-right">
                <Button
                  size="large"
                  type="primary"
                  onClick={this.goToClientsNew}
                >
                  <Icon type="plus" />
                  <FormattedMessage id="Component.Administration.Clients.List.Create" />
                </Button>
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={loading.models.clients || loading.models.app}>
          <AjaxTable
            getData={this.getData}
            rowKey="id"
            updateKey={JSON.stringify([filter, this.state.removedId])}
          >
            <Column
              dataIndex="name"
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
              sorter
              render={data => <div>{data}</div>}
            />
            <Column
              dataIndex="email"
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Email' })}
              sorter
              render={data => <div>{data}</div>}
            />
            <Column
              dataIndex="is_disabled"
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Active' })}
              render={data => <div>{this.props.intl.formatMessage({ id: data ? 'Common.No' : 'Common.Yes' })}</div>}
            />
            <Column
              dataIndex="status"
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Status' })}
              render={data => <div>{this.props.intl.formatMessage({ id: clientStatusToTextLabel[data] })}</div>}
            />
            <Column
              dataIndex="client_package"
              title={this.props.intl.formatMessage({ id: 'Component.Administration.Clients.Package' })}
              render={data => <div>{data ? data.title : '-'}</div>}
            />
            <Column
              dataIndex="signed_till"
              title={this.props.intl.formatMessage({ id: 'Component.Administration.Clients.SignedTill' })}
              sorter
              render={data => <div>{data ? moment(data).locale('de').format('LL') : '-'}</div>}
            />
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={selectedClientId === item.id ? null : this.props.intl.formatMessage({
                      id: 'Component.Administration.Clients.List.Action.Select',
                    })}
                  >
                    <button
                      onClick={() => selectedClientId !== item.id && this.selectClient(item)}
                      className={selectedClientId === item.id ? 'disabled' : ''}
                    >
                      <SelectIcon />
                    </button>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`./${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={() => this.showDeleteConfirm(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(({ loading, app }) => ({
  loading,
  app,
}))(injectIntl(ClientsList));



// WEBPACK FOOTER //
// ./src/components/Clients/ClientsList/index.js